import { fetchBillingSupplierConfig } from 'actions/billing'
import SchemaForm from 'components/forms/SchemaForm'
import billingSupplierConfigSchema from 'forms/superuser/billingSupplierConfigSchema'
import React from 'react'
import { connect } from 'react-redux'

class BillingSupplierConfigForm extends React.Component {
  componentDidMount () {
    this.props.fetchSupplierConfig()
  }

  render () {
    return <SchemaForm entityName='billingSupplierConfig' {...this.props}/>
  }
}

const mapStateToProps = (state, ownProps) => ({
  uiSchema: billingSupplierConfigSchema(state, ownProps),
  submitButton: true
})

const mapDispatchToProps = (dispatch) => ({
  fetchSupplierConfig: () => dispatch(fetchBillingSupplierConfig())
})

export default connect(mapStateToProps, mapDispatchToProps)(BillingSupplierConfigForm)
